import { ArrowRight, CheckCircle, Star } from "lucide-react";

// Horarios Printacce (Nicaragua UTC-6)
// Lun-Vie: 8:00 AM – 5:00 PM | Sábado: 8:00 AM – 4:00 PM | Domingo: Cerrado
function getBusinessStatus() {
  const now = new Date();
  // Nicaragua is UTC-6, no DST
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const nica = new Date(utc - 6 * 3600000);
  const day = nica.getDay(); // 0=Dom, 1=Lun...6=Sáb
  const hour = nica.getHours();
  const min = nica.getMinutes();
  const time = hour + min / 60;

  if (day >= 1 && day <= 5 && time >= 8 && time < 17) return true;  // Lun-Vie 8-17
  if (day === 6 && time >= 8 && time < 16) return true;              // Sáb 8-16
  return false;
}

const isOpen = getBusinessStatus();

const BADGES = [
  isOpen
    ? { text: "Abierto Ahora", color: "bg-green-100 text-green-700 border-green-200" }
    : { text: "Cerrado Ahora", color: "bg-red-50 text-red-600 border-red-200" },
  { text: "Atención Rápida", color: "bg-[#FFE4E8] text-[#E65B78] border-[#E65B78]/20" },
  { text: "Visa DS-160", color: "bg-blue-50 text-blue-700 border-blue-200" },
];

const TRUST = [
  "Impresiones de alta calidad",
  "Asesoría profesional para Visa",
  "Entrada UCC, 1/2 c. arriba y 1/2 abajo, casa 93. Altamira",
];

export default function HeroSection() {
  return (
    <section
      id="inicio"
      className="hero-gradient min-h-screen flex items-center pt-20 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left Content */}
          <div className="fade-in-left">
            {/* Overline */}
            <div
              data-testid="hero-badges"
              className="flex flex-wrap gap-2 mb-6"
            >
              {BADGES.map((b) => (
                <span
                  key={b.text}
                  className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full border ${b.color}`}
                >
                  {b.text}
                </span>
              ))}
            </div>

            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#E65B78] mb-4">
              Altamira, Managua, Nicaragua
            </p>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none text-[#111111] mb-6">
              Tu Centro de{" "}
              <span className="gradient-text">Impresión</span>{" "}
              y Trámites
            </h1>

            <p className="text-base md:text-lg leading-relaxed text-[#5C5C5C] mb-8 max-w-lg">
              Imprimimos tus documentos y planos, te asistimos con el formulario
              <strong className="text-[#111111]"> DS-160 para Visa Americana</strong>, y
              vendemos los accesorios electrónicos que necesitas. Todo en un solo lugar.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a
                href="#servicios"
                data-testid="hero-services-btn"
                className="inline-flex items-center justify-center gap-2 bg-[#E65B78] hover:bg-[#D44B66] text-white font-bold px-7 py-3.5 rounded-full transition-all duration-200 shadow-md hover:shadow-lg"
              >
                Ver Servicios
                <ArrowRight size={18} />
              </a>
              <a
                href="https://wa.me/50589984547?text=Hola%20Printacce%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-[#111111] font-bold px-7 py-3.5 rounded-full border-2 border-gray-200 transition-all duration-200 hover:border-[#E65B78]"
              >
                <svg className="w-5 h-5" fill="#25D366" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Escríbenos por WhatsApp
              </a>
            </div>

            <div className="flex flex-col gap-2">
              {TRUST.map((t) => (
                <div key={t} className="flex items-center gap-2">
                  <CheckCircle size={16} className="text-[#E65B78] flex-shrink-0" />
                  <span className="text-sm text-[#5C5C5C] font-medium">{t}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content */}
          <div className="fade-in-right delay-200 relative flex flex-col justify-center lg:justify-end gap-4">
            {/* Image — catálogo (sin foto de personas) */}
            <div className="relative w-full max-w-md mx-auto lg:mx-0">
              <div className="rounded-3xl shadow-2xl overflow-hidden bg-[#FFF5F7] border border-[#E65B78]/10">
                <img
                  src="/images/catalogo-accesorios.jpeg"
                  alt="Catálogo de accesorios Printacce"
                  className="w-full object-contain h-[420px] md:h-[500px]"
                />
              </div>
              {/* Dynamic open/closed badge */}
              <div className={`absolute left-4 bottom-4 rounded-2xl shadow-lg px-4 py-2.5 flex items-center gap-2 ${isOpen ? "bg-[#E65B78]" : "bg-gray-700"}`}>
                <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${isOpen ? "bg-green-400 animate-pulse" : "bg-red-400"}`}></span>
                <p className="text-white text-sm font-bold">{isOpen ? "Abierto Ahora" : "Cerrado Ahora"}</p>
              </div>
            </div>

            {/* Stats row — below the image, never overlapping */}
            <div className="flex items-center justify-center lg:justify-start gap-3 w-full max-w-md mx-auto lg:mx-0">
              <div className="flex-1 bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3 flex items-center gap-3">
                <div className="bg-[#FFE4E8] rounded-xl p-2 flex-shrink-0">
                  <Star size={16} className="text-[#E65B78] fill-[#E65B78]" />
                </div>
                <div>
                  <p className="text-[10px] text-[#5C5C5C] font-medium leading-none mb-0.5">Calificación</p>
                  <p className="text-sm font-bold text-[#111111]">5.0 Excelente</p>
                </div>
              </div>
              <div className="flex-1 bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3">
                <p className="text-2xl font-black text-[#E65B78] leading-none">500+</p>
                <p className="text-[10px] text-[#5C5C5C] font-medium mt-0.5">Clientes Satisfechos</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
